<template>
  <core-Form ref="form" :model="'form'">
      <b-row>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Agência">
                  <b-input v-model="form.agencia" disabled></b-input>
              </b-form-group>
          </b-col>

          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Agência Dígito">
                  <b-input v-model="form.agenciaDigito" disabled></b-input>
              </b-form-group>
          </b-col>

          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Conta">
                  <b-input v-model="form.conta" disabled></b-input>
              </b-form-group>
          </b-col>

          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Conta Dígito">
                  <b-input v-model="form.contaDigito" disabled></b-input>
              </b-form-group>
          </b-col>

          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Conta Pagamento">
                  <b-input v-model="form.contaPgto" disabled></b-input>
              </b-form-group>
          </b-col>

          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Tipo de conta">
                  <b-form-select v-model="form.tipoConta" :options="$api.Arrays.TiposConta"></b-form-select>
              </b-form-group>
          </b-col>

      </b-row>
  </core-Form>
</template>

<script>
export default {
  props: {
    rastreada: {
      type: Boolean,
      default: false
    },
    contaDebito: {
      type: Object
    },
    dadosBancariosPix: {
      type: Object
    }
  },
  watch: {
  },
  data () {
    return {
      form: {
        chave: null
      },
        dados: {},
      readonly: false
    }
  },
  computed: {
    model: {
      get () {
        var obj = this.value
        return obj
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    validate () {
    },
    limparDados () {
      this.dados = {}
    },
  }
}
</script>
